import { computed } from '@nuxtjs/composition-api'
import CrossIcon from '~/assets/images/mobile-navigation-cross.svg?inline'


export default {
  __name: 'w-chip',
  props: {
  icon: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
    required: true,
  },

  to: {
    type: [Object, String],
    required: false,
    default: undefined,
  },

  variant: {
    type: String,
    required: false,
    default: 'default',
    validator: (value) => ['default', 'filter'].includes(value),
  },
  isLabel: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  setup(__props) {

const { to, variant } = __props;



const componentName = computed(() => (to ? 'NuxtLink' : 'div'))
const isFilterChip = computed(() => variant === 'filter')
const isInteractive = computed(() => typeof to !== 'undefined')

return { __sfc: true,componentName, isFilterChip, isInteractive, CrossIcon }
}

}